import { createSlice } from "@reduxjs/toolkit";
import { server_url } from "../core/config_geral";
import { converterDataParaString, formatarDataParaString, gerarGUID, obterDataAtual } from "./livrudo_helpers";

function initStateDB() {
    return {
        livros: [],
        skus: [],
        estados: [],
        resultados: null,
    }
}
const initialState = {
    loading: true,
    db: initStateDB(),
    formBuscaLivro: novoFormBuscaLivro(),
    resultados: null,
    dashboard: {
        faturamento: 0,
        lucro: 0,
        estoqueComprado: 0,
        estoqueCancelado: 0,
        estoqueVendido: 0,
        underwater: 0,
    }
}

function novoFormBuscaLivro() {
    return {
        "query": ""
    }
}

function novoFormAddLivro() {
    return {
        "nome": "",
        "isbn": "",
        "tipo": "",
        "categoria": "",
        "editora": "",
        "data": formatarDataParaString(obterDataAtual()),
        "erro": null
    }
}

export function novoLivro(
    id,
    nome,
    isbn,
    editora,
    tipo,
    categoria,
    data
) {
    return {
        id, nome, isbn, editora, tipo, categoria, data
    }
}
export function novoEstado(obj) {
    return {
        ...obj,
        id: gerarGUID(),
        data: converterDataParaString(obterDataAtual())
    }
}

export const livrudoSlice = createSlice({
    name: "livrudo",
    initialState,
    reducers: {
        triggerFirstLoad: () => { },
        carregaLivrudoDB: (state, action) => {
            var db = action.payload
            db.livros.sort((a, b) => new Date(a.data) - new Date(b.data));
            state.db = db
        },
        calculaResultadosLivrudo: (state) => {


            function getMonthAndYear(dateString) {
                const [year, month] = dateString.split("-");
                return `${year}-${month}`;
            }

            function simplePlataforma(plataforma) {
                return plataforma.toLowerCase().replace(" ", "_")
            }

            function valoresZerados() {
                return {
                    total: 0,
                    olx: 0,
                    enjoei: 0,
                    amazon: 0,
                    "estante_virtual": 0,
                    mercadolivre: 0,
                }
            }

            var compras = {}
            var vendas = {}

            state.db.skus.forEach(e => {
                // console.log({...e})
                // console.log(getMonthAndYear(e.data), e.nome)

                const key = getMonthAndYear(e.data)

                if (typeof (compras[key]) == "undefined") {
                    compras[key] = {
                        valor: valoresZerados(),
                        qtde: valoresZerados()
                    };
                }

                compras[key].valor.total += parseFloat(e.preco)
                compras[key].valor[simplePlataforma(e.plataforma)] += parseFloat(e.preco)
                compras[key].qtde.total += 1
                compras[key].qtde[simplePlataforma(e.plataforma)] += 1


                if (typeof (e.venda) != "undefined") {
                    const sKey = getMonthAndYear(e.venda.data)

                    if (sKey == "2024-01") {
                        console.log({ ...e })
                        // console.log({...state.db.livros[0]})
                        console.log({ ...state.db.livros.filter(l => l.id == "ID-09748236")[0] })
                    }
                    if (typeof (vendas[sKey]) == "undefined") {
                        vendas[sKey] = {
                            valorVenda: valoresZerados(),
                            valorCompra: valoresZerados(),
                            qtde: valoresZerados(),
                            lucro: valoresZerados(),
                            tarifa: valoresZerados(),
                            liquido: valoresZerados(),
                        };
                    }
                    vendas[sKey].valorVenda.total += parseFloat(e.venda.preco)
                    vendas[sKey].valorVenda[simplePlataforma(e.venda.plataforma)] += parseFloat(e.venda.preco)
                    vendas[sKey].valorCompra.total += parseFloat(e.preco)
                    vendas[sKey].valorCompra[simplePlataforma(e.venda.plataforma)] += parseFloat(e.preco)
                    vendas[sKey].qtde.total += 1
                    vendas[sKey].qtde[simplePlataforma(e.venda.plataforma)] += 1
                    vendas[sKey].lucro.total += parseFloat(e.venda.lucro)
                    vendas[sKey].lucro[simplePlataforma(e.venda.plataforma)] += parseFloat(e.venda.lucro)
                    vendas[sKey].tarifa.total += parseFloat(e.venda.tarifa)
                    vendas[sKey].tarifa[simplePlataforma(e.venda.plataforma)] += parseFloat(e.venda.tarifa)
                    vendas[sKey].liquido.total = vendas[sKey].valorVenda.total - vendas[sKey].tarifa.total
                }
            })

            state.resultados = {
                compras: compras,
                vendas: vendas,
            }
            // console.log(compras)
            // console.log(vendas)

        },
        livrudoDbChangeAttr: (state, action) => {
            state.db[action.payload.campo] = action.payload.valor
        },
        changeFormBuscaLivro: (state, action) => {
            state.formBuscaLivro = action.payload
        },
        salvarLivro: (state, action) => {
            var livros = [...state.db.livros]
            livros.push(action.payload)
            state.db.livros = livros
        },
        salvarLivroEditado : (state, action) => {
            var livros = [...state.db.livros]
            var livro  = action.payload

            var found = false
            for (var i = 0; i < livros.length; i++) {
                if (livros[i].id == livro.id) {
                    livros[i] = livro
                    found = true
                }
            }

            // if(found) {
                // console.log(found);
            // }

            // console.log(livros);
            state.db.livros = livros
        },
        salvarEstado: (state, action) => {
            var estados = [...state.db.estados]
            var estado = action.payload

            var found = false
            for (var i = 0; i < estados.length; i++) {
                if (estados[i].id == estado.id) {
                    estados[i] = estado
                    found = true
                }
            }

            if (!found) {
                estados.push(estado)
            }

            state.db.estados = estados
        },
        salvarSku: (state, action) => {
            var skus = [...state.db.skus]
            var sku = action.payload

            var found = false
            for (var i = 0; i < skus.length; i++) {
                if (skus[i].sku == sku.sku) {
                    skus[i] = sku
                    found = true
                }
            }

            if (!found) {
                skus.push(sku)
            }

            state.db.skus = skus
        },
        //Só use para resovler problemas
        trocaSkus: (state, action) => {
            state.db.skus = action.payload
        },
        //Só use para resovler problemas
        trocaEstados: (state, action) => {
            state.db.estados = action.payload
        },
        //Só use para resolver problemas
        trocaLivros: (state, action) => {
            state.db.livros = action.payload
        },
        calculaLivrudoDashboard: (state) => {

            var estoqueComprado = state.db.skus
                .reduce((total, item) => total + parseFloat(item.preco), 0);
            var estoqueCancelado = state.db.skus
                .filter(e =>
                    e.ultimoEstado == "RECEBIDO_RECUSADO_AGUARDANDO_MEDIACAO" ||
                    e.ultimoEstado == "MEDIACAO_CONCLUIDA" ||
                    e.ultimoEstado == "COMPRADO_CANCELADO")
                .reduce((total, item) => total + parseFloat(item.preco), 0);
            var custoEstoqueVenda = state.db.skus.
                filter(p => typeof (p.venda) != "undefined")
                .reduce((total, item) => total + parseFloat(item.preco), 0)
            var lucro = state.db.skus.
                filter(p => typeof (p.venda) != "undefined")
                .reduce((total, item) => total + parseFloat(item.venda.lucro), 0)
            var faturamento = state.db.skus.
                filter(p => typeof (p.venda) != "undefined")
                .reduce((total, item) => total + (parseFloat(item.venda.preco) - parseFloat(item.venda.tarifa)), 0)

            state.dashboard.estoqueComprado = estoqueComprado
            state.dashboard.estoqueCancelado = estoqueCancelado
            state.dashboard.estoqueVendido = custoEstoqueVenda
            state.dashboard.lucro = lucro
            state.dashboard.faturamento = faturamento
            state.dashboard.underwater = estoqueComprado - estoqueCancelado - faturamento
        }
    }
});


export const {
    triggerFirstLoad,
    carregaLivrudoDB,
    livrudoDbChangeAttr,
    changeFormBuscaLivro,
    salvarLivro,
    salvarLivroEditado,
    salvarSku,
    salvarEstado,
    trocaSkus,
    trocaEstados,
    trocaLivros,
    calculaLivrudoDashboard,
    calculaResultadosLivrudo
} = livrudoSlice.actions;

export default livrudoSlice.reducer;